import { BRANDS } from "@/config/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

const MarqueeRow = () => (
  <div className="flex w-max shrink-0 items-center">
    {BRANDS.map((b) => (
      <span key={b} className="flex items-center">
        <span className="font-display px-8 text-2xl font-bold tracking-tight text-[#1c1d1f]/35 sm:text-3xl">{b}</span>
        <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-[#0050e0]/40" />
      </span>
    ))}
  </div>
);

export default function Brands() {
  return (
    <section id="brand" className="section-pad scroll-mt-20 bg-[#f3efea]" data-testid="brands-section">
      <div className="container-x">
        <SectionHeading
          number="01"
          label="Brand selezionati"
          title="Una selezione che fa la differenza."
          sub="Marchi scelti per qualità, innovazione ed efficacia."
        />
      </div>

      <Reveal delay={0.15} className="marquee-mask mt-12 overflow-hidden" y={12}>
        <div className="animate-marquee flex w-max" aria-hidden="true">
          <MarqueeRow />
          <MarqueeRow />
        </div>
      </Reveal>

      <div className="container-x mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-5 lg:grid-cols-4">
        {BRANDS.map((b, i) => (
          <Reveal key={b} delay={i * 0.06} y={20}>
            <div
              data-testid={`brand-card-${b.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="card card-hover flex h-24 items-center justify-center sm:h-28"
            >
              <span className="font-display text-lg font-bold tracking-wide text-[#1c1d1f]/70 transition-colors duration-300 sm:text-xl">
                {b}
              </span>
            </div>
          </Reveal>
        ))}
        <Reveal delay={BRANDS.length * 0.06} y={20}>
          <div className="flex h-24 items-center justify-center rounded-3xl border border-dashed border-black/15 sm:h-28">
            <span className="text-sm font-medium text-[#888c95]">e molti altri in Parafarmacia</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
